// Load css file
const loadCss = (fileName) => {
  return new Promise((resolve, reject) => {
    const link = document.createElement("link");
    const fileId = `${fileName.toUpperCase()?.replace("-", "")}CSS`;
    const mainPath = document.getElementById("MainCssPath").href;
    link.onload = resolve;
    link.onerror = reject;
    link.id = fileId;
    link.rel = "stylesheet";
    link.type = "text/css";
    link.href = mainPath.includes("?v")
      ? mainPath
          .split("?v")[0]
          ?.replace("/assets/main.css", `/assets/${fileName}.css?v=1`)
      : mainPath.replace("/assets/main.css", `/assets/${fileName}.css?v=1`);
    link.media = "all";
    if (!document.getElementById(fileId)) {
      document.head.appendChild(link);
    }
  });
};
// Load js file
const loadScript = (fileName) => {
  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    const fileId = `${fileName.toUpperCase()?.replace("-", "")}JS`;
    const mainPath = document.getElementById("MainJsPath").src;
    script.onload = resolve;
    script.onerror = reject;
    script.async = true;
    script.id = fileId;
    script.type = "text/javascript";
    script.src = mainPath.includes("?v")
      ? mainPath
          .split("?v")[0]
          ?.replace("/assets/main.js", `/assets/${fileName}.js`)
      : mainPath.replace("/assets/main.js", `/assets/${fileName}.js`);
    // cache buster - uncomment next line to disable cache
    script.src += "?v=" + Math.floor(Math.random() * 1000);
    if (!document.getElementById(fileId)) {
      document.head.appendChild(script);
    }
  });
};
// Scroll animation observer
const scrollAnimationObserver = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("scroll-animation--active");
        scrollAnimationObserver.unobserve(entry.target);
      }
    });
  },
  {
    threshold: 0.25,
  }
);

(function scrollAnimationInit() {
  if (!document.documentElement.classList.contains("js-scroll-animations"))
    return;

  document.querySelectorAll(".scroll-animation").forEach((el, i) => {
    scrollAnimationObserver.observe(el);
  });
})();
// Add helper class when announcement bar is enabled
window.addEventListener("DOMContentLoaded", () => {
  if (document.querySelector(".announcement-bar") != null) {
    document.body.classList.add("is-announcement-bar");
  }
});
// Helper functions
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled:not(.modal-trigger), [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe, .drawer:not(.search-drawer), modal-dialog"
    )
  );
}
// ADA change July 2026
function getFocusableElementsMobileMenu(container) {
  const drawer = container.querySelector("#menu-drawer, .mmenu-drawer");
  return drawer
    ? getFocusableElements(drawer)
    : getFocusableElements(container);
}

function getTrapFocusableElements(container) {
  let elements = getFocusableElements(container);

  if (container.classList.contains("mobile-menu")) {
    elements = getFocusableElementsMobileMenu(container);
  }

  return elements.filter((el) => {
    const rect = el.getBoundingClientRect();
    const style = window.getComputedStyle(el);
    return (
      rect.width > 0 &&
      rect.height > 0 &&
      style.display !== "none" &&
      style.visibility !== "hidden" &&
      el.closest('[aria-hidden="true"]') === null
    );
  });
}

const trapFocusHandlers = {};
function trapFocus(container, elementToFocus = container) {
  removeTrapFocus();

  trapFocusHandlers.container = container;

  // ADA change July 2026: Strict focus trap - if focus goes outside container while modal is open, pull it back in
  trapFocusHandlers.focusin = (event) => {
    const modalContent = container.classList.contains("mobile-menu")
      ? container.querySelector("#menu-drawer, .mmenu-drawer")
      : container;

    if (modalContent && modalContent.contains(event.target)) return;

    const elements = getTrapFocusableElements(container);
    if (elements.length === 0) return;

    event.preventDefault();
    elements[0].focus();
  };

  // ADA change July 2026: Strict tab loop inside open modal/drawer
  trapFocusHandlers.keydown = function (event) {
    if (event.key !== "Tab" && event.code.toUpperCase() !== "TAB") return;

    const elements = getTrapFocusableElements(container);
    if (elements.length === 0) return;

    const first = elements[0];
    const last = elements[elements.length - 1];

    const activeEl = document.activeElement;
    const activeIndex = elements.indexOf(activeEl);
    const isLast = (activeEl === last || activeIndex === elements.length - 1);
    const isFirst = (activeEl === first || activeIndex === 0 || activeEl === container);

    if (!event.shiftKey) {
      if (isLast || !container.contains(activeEl)) {
        event.preventDefault();
        first.focus();
      }
    } else {
      if (isFirst || !container.contains(activeEl)) {
        event.preventDefault();
        last.focus();
      }
    }
  };

  document.addEventListener("focusin", trapFocusHandlers.focusin);
  document.addEventListener("keydown", trapFocusHandlers.keydown);

  // ADA change July 2026: Prioritize explicit elementToFocus inside drawer over outer container buttons
  const focusTarget = (elementToFocus && elementToFocus !== container)
    ? (elementToFocus.querySelector(".drawer-close, .mmenu__close") || elementToFocus)
    : (container.querySelector(".drawer-close, .mmenu__close") || container.querySelector("button") || container);

  if (focusTarget && typeof focusTarget.focus === "function") {
    focusTarget.focus();
  }
}
function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);
  delete trapFocusHandlers.container;

  if (elementToFocus && typeof elementToFocus.focus === "function") {
    elementToFocus.focus();
  }
}
// Details animation
function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  //const openDetailsElement = event.target.closest('details[open]');
  const openDetailsElement = event.target.closest(".details--active");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector(".summary");
  openDetailsElement.classList.remove("details--active");
  const toggleBtn = summaryElement.querySelector(".toggle-btn") || (summaryElement.tagName === 'BUTTON' || summaryElement.tagName === 'SUMMARY' ? summaryElement : null);
  if (toggleBtn && !toggleBtn.classList.contains("mmenu__hamburger")) {
    toggleBtn.setAttribute("aria-expanded", false);
  }
  if (
    summaryElement.classList.contains("mmenu__hamburger") &&
    document.body.classList.contains("mmenu--open")
  ) {
    document.body.classList.remove("mmenu--open");
  }
  // ADA change July 2026
  removeTrapFocus(summaryElement);
}

class Accordion {
  constructor(el) {
    if (!el) return;
    this.details = el;
    this.summary = el.querySelector(".summary");
    this.content = el.querySelector(".details__content");

    // ADA change July 2026: Guard against details containers missing a summary element
    if (!this.summary) return;
    // Filter markup is replaced after AJAX; only bind each summary once.
    if (this.summary.dataset.accordionBound === "true") return;
    this.summary.dataset.accordionBound = "true";

    this.summary.addEventListener("click", (event) => this.onClick(event));
    // ADA change July 2026
    this.details.querySelectorAll(".mmenu__close").forEach((closeBtn) => {
      if (closeBtn.dataset.accordionBound === "true") return;
      closeBtn.dataset.accordionBound = "true";
      closeBtn.addEventListener("click", (event) => {
        event.preventDefault();
        this.collapse();
      });
    });
    if (this.details.dataset.accordionKeyBound !== "true") {
      this.details.dataset.accordionKeyBound = "true";
      this.details.addEventListener("keyup", onKeyUpEscape);
    }

    if (this.details.dataset.accordionInitBound === "true") return;
    this.details.dataset.accordionInitBound = "true";

    // Call immediately if DOM is already loaded, otherwise wait for DOMContentLoaded
    if (document.readyState === 'loading') {
      window.addEventListener("DOMContentLoaded", () => this.mobileOnlyDetails());
    } else {
      // DOM is already loaded (common in customizer)
      this.mobileOnlyDetails();
    }
    
    // Skip resize listener for footer accordions so scroll (e.g. mobile address bar hide) doesn't collapse expanded menus
    if (!this.details.closest(".site-footer")) {
      window.addEventListener("resize", () => {
        this.mobileOnlyDetails();
      });
    }
  }

  onClick(event) {
    event.preventDefault();
    console.log("this.details");
    console.log(this.details);
    console.log("event");
    console.log(event);

    // ADA change July 2026: Clean toggle of mobile drawer details active and overlay body class
    if (this.details.classList.contains("details--active")) {
      this.collapse();
    } else {
      this.expand();
    }
  }

  collapse() {
    this.details.classList.remove("details--active");
    if (this.summary.classList.contains("mmenu__hamburger")) {
      // if mobile menu
      document.body.classList.remove("mmenu--open");
      setTimeout(() => {
        Array.from(document.getElementsByClassName("show")).forEach((el) => {
          el.classList.remove("show");
          el.classList.add("hide");
        });
      }, 250);
    }
    //window.removeEventListener('keydown', trapFocusHandlers);
    //console.log('collapse')
    // ADA change July 2026
    removeTrapFocus(this.summary);
    // setTimeout(() => {
    //   this.details.removeAttribute('open');
    // }, 500);

    const toggleBtn = this.summary.querySelector(".toggle-btn") || (this.summary.tagName === 'BUTTON' || this.summary.tagName === 'SUMMARY' ? this.summary : null);
    if (toggleBtn && !toggleBtn.classList.contains("mmenu__hamburger")) {
      toggleBtn.setAttribute("aria-expanded", "false");
    }
  }

  expand() {
    // this.details.setAttribute('open', '');
    if (this.summary.classList.contains("mmenu__hamburger")) {
      // if mobile menu
      document.body.classList.add("mmenu--open");
      // ADA change July 2026
      const drawer = this.details.querySelector("#menu-drawer, .mmenu-drawer");
      const closeBtn = drawer?.querySelector(".mmenu__close, .drawer-close");
      const targetFocus = closeBtn || drawer;
      trapFocus(this.details, targetFocus);
      Array.from(document.getElementsByClassName("hide")).forEach((el) => {
        el.classList.remove("hide");
        el.classList.add("show");
      });
    }
    if (this.details.closest(".drawer--filter")) {
      this.details.classList.add("details--active");
    } else {
      setTimeout(() => {
        this.details.classList.add("details--active");
      }, 50);
    }

    const toggleBtn = this.summary.querySelector(".toggle-btn") || (this.summary.tagName === 'BUTTON' || this.summary.tagName === 'SUMMARY' ? this.summary : null);
    if (toggleBtn && !toggleBtn.classList.contains("mmenu__hamburger")) {
      toggleBtn.setAttribute("aria-expanded", "true");
    }
  }

  mobileOnlyDetails() {
    if (
      this.details.classList.contains("mobile--only") &&
      !this.details.classList.contains("class--shop")
    ) {
      if (window.innerWidth < 769) {
        this.collapse();
      } else {
        this.expand();
      }
    } else if (
      this.details.classList.contains("mobile--only") &&
      this.details.classList.contains("class--shop")
    ) {
      this.expand();
    }
  }
}
document.querySelectorAll('[id^="Details-"]').forEach((el) => {
  new Accordion(el);
});

// Reinitialize Accordion instances when sections load in customizer
document.addEventListener('shopify:section:load', function (event) {
  const sectionElement = event.target;
  const detailsElements = sectionElement.querySelectorAll('[id^="Details-"]');
  detailsElements.forEach((el) => {
    // Only initialize if not already initialized
    if (!el.hasAttribute('data-accordion-initialized')) {
      new Accordion(el);
      el.setAttribute('data-accordion-initialized', 'true');
    }
  });
});

// Check if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}
function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.onLoad();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    const currentVariantId = this.currentVariant.id;
    const preOrderNote = window.variantMetafields[currentVariantId];
    console.log("currentVariantId: ", currentVariantId);
    console.log("preOrderNote: ", preOrderNote);
    if (preOrderNote) {
      const atcButton = document.getElementById("AddToCartButton");
      const atcSpan = atcButton.querySelector("span");
      if (document.querySelector("#BIS_trigger")) {
        document.querySelector("#BIS_trigger").classList.add("hide");
      }
      setTimeout(() => {
        atcSpan.textContent = "Preorder Now";
        atcButton.removeAttribute("disabled");
      }, "500");

      if (preOrderNote != "nothing") {
        if (!document.querySelector(".preorder")) {
          // Create and insert the message
          const preorderMessage = document.createElement("p");
          preorderMessage.className = "preorder";
          preorderMessage.style.marginTop = ".75rem";
          preorderMessage.innerHTML = `Expected ship date:&nbsp;<span class="preorder-date">${preOrderNote}</span>`;
          document
            .getElementById("AddToCartButton")
            .insertAdjacentElement("afterend", preorderMessage);

          // Create and insert the hidden input
          const hiddenInput = document.createElement("input");
          hiddenInput.type = "hidden";
          hiddenInput.className = "preorder-input";
          hiddenInput.name = "properties[Pre-order]";
          hiddenInput.value = preOrderNote;
          document
            .getElementById("AddToCartButton")
            .insertAdjacentElement("afterend", hiddenInput);
        } else {
          if (document.querySelector(".preorder")) {
            document.querySelector(
              ".preorder .preorder-date"
            ).innerHTML = `${preOrderNote}`;
            document.querySelector(".preorder-input").value = preOrderNote;
          }
        }
      }

      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.updateUnavailableVariants();
      //this.updateSelectedValues();
    } else if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
      if (document.querySelector("#BIS_trigger")) {
        document.querySelector("#BIS_trigger").classList.remove("hide");
      }
      if (document.querySelector(".preorder")) {
        document.querySelector(".preorder").remove();
        document.querySelector('[name="properties[Pre-order]"]').remove();
      }
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.updateUnavailableVariants();
      //this.updateSelectedValues();
      if (document.querySelector("#BIS_trigger")) {
        document.querySelector("#BIS_trigger").classList.remove("hide");
      }
      if (document.querySelector(".preorder")) {
        document.querySelector(".preorder").remove();
        document.querySelector('[name="properties[Pre-order]"]').remove();
      }
    }
  }

  onLoad() {
    this.updateUnavailableVariants();
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          //console.log('option')
          //console.log(option)
          //console.log('this.options[index]')
          //console.log(this.options[index])
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const variantImage = this.currentVariant.featured_media.preview_image.src;

    if (this.closest(".product-card")) {
      const media = this.closest(".product-card").querySelector(
        ".product-card__media .media--primary"
      );
      media.innerHTML = `<img src="${variantImage}&width=1440">`;
    } else {
      const carousel = document.querySelector("#main-carousel");
      if (!carousel) return;
      const media = carousel.querySelector(
        `.splide__slide[data-media-position="${this.currentVariant.featured_media.position}"]`
      );
      const mediaContainer = carousel.querySelector(".splide__list");

      if (carousel.classList.contains("is-active")) {
        var Slides = main.Components.Slides.filter(".product__media-item");

        if (Slides[this.currentVariant.featured_media.position]) {
          if (carousel.classList.contains("splide--loop")) {
            main.go(
              Slides[this.currentVariant.featured_media.position].index + 1
            );
          } else {
            main.go(
              Slides[this.currentVariant.featured_media.position].index - 1
            );
          }
        }
      } else {
        media.scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest",
        });
      }
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton) return;
    const urlInput = shareButton.querySelector("input");
    let urlToShare = urlInput ? urlInput.value : document.location.href;
    const url = `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`;
    urlToShare = url;
    urlInput.value = url;
  }

  updateVariantInput() {
    if (this.closest(".product-card")) {
      if (this.closest("form")) {
        const productCardInput =
          this.closest("form").querySelector('input[name="id"]');
        productCardInput.value = this.currentVariant.id;
        productCardInput.dispatchEvent(new Event("change", { bubbles: true }));
      }
    } else {
      const productForms = document.querySelectorAll(
        `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
      );
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event("change", { bubbles: true }));

        let inv_qty = this.currentVariant.inventory_quantity;
        const lowStockBadge = document.querySelector(".low_stock_badge");
        if (inv_qty > 0 && inv_qty < 4) {
          lowStockBadge.querySelector(".inventory_quantity-text").textContent =
            inv_qty;
          lowStockBadge.style.display = "block";
        } else {
          lowStockBadge.style.display = "none";
        }
      });
    }
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.style.display = "block";
    } else {
      pickUpAvailability.style.display = "none";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url.split("?")[0]}.json`)
      .then((response) => {
        if (!response || !response.ok) {
          throw new Error('Failed to fetch product info');
        }
        return response.json();
      })
      .then((data) => {
        const variant = data.product.variants.filter((v) => {
          return v.id === this.currentVariant.id;
        });

        const symbol = document
          .querySelectorAll(".price-item")[0]
          .innerHTML.charAt(0);
        let currency = document
          .querySelectorAll(".price-item")[0]
          .innerHTML.split(" ")[1];
        if (currency == undefined) currency = "";
        let price, compare_price, saleBadge;
        const soldOutBadge = document.querySelector(
          ".product-wrapper .badge--sold"
        );
        let compare_at_price = variant[0].compare_at_price;
        if (compare_at_price != "") {
          compare_at_price =
            symbol + variant[0].compare_at_price + " " + currency;
        }

        if (this.closest(".product-card")) {
          price = this.closest(".product-card").querySelector(
            ".price-item--regular"
          );
          compare_price = this.closest(".product-card").querySelector(
            ".price-item--compare"
          );
          saleBadge =
            this.closest(".product-card").querySelector(".badge--sale");
        } else {
          price = this.closest(".product__info").querySelector(
            ".price-item--regular"
          );
          compare_price = this.closest(".product__info").querySelector(
            ".price-item--compare"
          );
          saleBadge =
            this.closest(".product__info").querySelector(".badge--sale");
        }

        if (price.closest(".price").querySelector(".price-varies__label")) {
          price
            .closest(".price")
            .querySelector(".price-varies__label")
            .remove();
        }

        price.innerHTML = symbol + variant[0].price + " " + currency;

        if (
          parseFloat(variant[0].compare_at_price) > parseFloat(variant[0].price)
        ) {
          if (compare_price) {
            compare_price.innerHTML = compare_at_price;
          } else {
            const comparePriceNew = document.createElement("s");
            comparePriceNew.className += "price-item price-item--compare";
            comparePriceNew.textContent = compare_at_price;
            price
              .closest(".price-item--regular")
              .parentNode.insertBefore(
                comparePriceNew,
                price.closest(".price-item--regular").nextSibling
              );
          }

          if (saleBadge) saleBadge.classList.remove("visually-hidden");
        } else {
          if (compare_price) {
            compare_price.innerHTML = "";
          }

          if (saleBadge) saleBadge.classList.add("visually-hidden");
        }

        if (!this.closest(".product-card")) {
          if (!this.currentVariant.available) {
            if (soldOutBadge) {
              soldOutBadge.classList.remove("visually-hidden");
            } else {
              const soldOutBadgeNew = document.createElement("span");
              soldOutBadgeNew.className += "badge badge--sold";
              soldOutBadgeNew.textContent = "Sold Out";
              document
                .querySelector(".single-product--form")
                .closest(".product__info")
                .querySelector(".price")
                .append(soldOutBadgeNew);
            }
          } else {
            if (soldOutBadge) {
              soldOutBadge.classList.add("visually-hidden");
            }
          }
        }

        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        );
      })
      .catch((error) => {
        console.error('Error fetching product info:', error);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    let productForm;

    const currentVariantId = this.currentVariant.id;
    const preOrderNote = window.variantMetafields[currentVariantId];

    if (this.closest(".product-card")) {
      productForm = this.closest("form");
    } else {
      productForm = document.querySelector(`.single-product--form`);
    }

    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      if (text) {
        console.log("preOrderNote", preOrderNote);
        if (preOrderNote) {
          addButtonText.textContent = "Preorder Now";
        } else {
          addButtonText.textContent = window.variantStrings.addToCart;
        }
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    let productForm;
    if (this.closest(".product-card")) {
      productForm = this.closest("form");
    } else {
      productForm = document.querySelector(`.single-product--form`);
    }

    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (addButton) {
      addButtonText.textContent = window.variantStrings.unavailable;
    }

    if (addButton.hasAttribute("hidden")) {
      addButton.removeAttribute("hidden");
      setTimeout(() => addButton.setAttribute("hidden", ""), 3000);
    } else {
    }
  }

  getVariantData() {
    if (!this.variantData) {
      const scriptElement = this.querySelector('[type="application/json"]');
      if (scriptElement && scriptElement.textContent) {
        try {
          this.variantData = JSON.parse(scriptElement.textContent);
        } catch (e) {
          console.error("Error parsing variant data:", e);
          this.variantData = [];
        }
      } else {
        console.warn("No variant data script found for", this);
        this.variantData = [];
      }
    }
    return this.variantData || [];
  }

  getSelectedOption(i) {
    if (this.dataset.type == "select") {
      return this.querySelectorAll(".product-form__input")[i].querySelector(
        "select"
      ).value;
    } else {
      let selectedOption = null;
      this.querySelectorAll(".product-form__input")
        [i].querySelectorAll("input")
        .forEach((elm) => {
          if (elm.checked) selectedOption = elm.value;
        });
      return selectedOption;
    }
  }

  setDisabledOption(i, option) {
    const target = this.querySelectorAll(".product-form__input")[
      i
    ].querySelector(`.variant-option[value="${option}"]`);
    if (target) {
      if (this.dataset.type == "select") {
        target.setAttribute("disabled", "");
      } else {
        target.classList.add("sold-out");
        target.parentNode
          .getElementsByTagName("label")[0]
          .insertAdjacentHTML(
            "beforeend",
            '<span class="visually-hidden">sold out</span>'
          );
      }
    }
  }

  resetDisabledOption(i) {
    this.querySelectorAll(".product-form__input")
      [i].querySelectorAll(".variant-option")
      .forEach((elm) => {
        if (this.dataset.type == "select") {
          elm.removeAttribute("disabled");
        } else {
          elm.classList.remove("sold-out");
        }
      });
  }

  updateUnavailableVariants() {
    if (this.dataset.hideVariants == "true") {
      const variantData = this.getVariantData();
      if (
        !variantData ||
        !Array.isArray(variantData) ||
        variantData.length === 0
      ) {
        return; // Exit early if no variant data available
      }

      let options1 = {},
        options2 = {},
        options3 = {},
        option1Selected = null,
        option2Selected = null;

      if (this.dataset.variants > 1) {
        option1Selected = this.getSelectedOption(0);
        this.resetDisabledOption(1);
      }
      if (this.dataset.variants > 2) {
        option2Selected = this.getSelectedOption(1);
        this.resetDisabledOption(2);
      }

      variantData.forEach((el) => {
        if (this.dataset.variants > 0) {
          if (!options1[el.option1]) {
            options1[el.option1] = [];
          }
          options1[el.option1].push(String(el.available));
        }
        if (this.dataset.variants > 1) {
          if (!options2[el.option2]) {
            options2[el.option2] = [];
          }
          options2[el.option2].push(String(el.available));
        }
        if (this.dataset.variants == 1) {
          if (!el.available) {
            this.setDisabledOption(0, el.option1);
          }
        }
        if (this.dataset.variants == 2) {
          if (el.option1 == option1Selected) {
            if (!el.available) this.setDisabledOption(1, el.option2);
          }
        }
        if (this.dataset.variants > 2) {
          if (!options3[el.option3]) {
            options3[el.option3] = [];
          }
          options3[el.option3].push(String(el.available));
          if (
            el.option2 == option2Selected &&
            el.option1 == option1Selected &&
            !el.available
          ) {
            this.setDisabledOption(2, el.option3);
          }
        }
      });
    }
  }

  // updateSelectedValues() {
  //   if (this.dataset.variants > 2) {
  //     this.querySelectorAll('.product-form__input')[0].querySelector('#selectedOption').textContent =
  //       this.getSelectedOption(0);
  //     this.querySelectorAll('.product-form__input')[1].querySelector('#selectedOption').textContent =
  //       this.getSelectedOption(1);
  //     this.querySelectorAll('.product-form__input')[2].querySelector('#selectedOption').textContent =
  //       this.getSelectedOption(2);
  //   } else if (this.dataset.variants > 1) {
  //     this.querySelectorAll('.product-form__input')[0].querySelector('#selectedOption').textContent =
  //       this.getSelectedOption(0);
  //     this.querySelectorAll('.product-form__input')[1].querySelector('#selectedOption').textContent =
  //       this.getSelectedOption(1);
  //   } else {
  //     this.querySelector('.product-form__input').querySelector('#selectedOption').textContent =
  //       this.getSelectedOption(0);
  //   }
  // }
}
customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  // ADA change July 2026: Native radio input option updating for PDP variant selection and gallery media sync
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll(".fieldset"));
    this.options = fieldsets.map((fieldset) => {
      const checkedRadio = Array.from(fieldset.querySelectorAll("input[type='radio']")).find(
        (radio) => radio.checked
      );
      if (checkedRadio) {
        fieldset.dataset.selectedOption = checkedRadio.value;
        return checkedRadio.value;
      }
      return fieldset.dataset.selectedOption || "";
    });
  }
}
customElements.define("variant-radios", VariantRadios);

class MainDrawer extends HTMLElement {
  constructor() {
    super();

    this.trigger = this.querySelector(".drawer__trigger");
    this.drawer = this.querySelector(".drawer");
    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.closeDrawer()
    );
    this.querySelectorAll(".drawer-close").forEach((el) =>
      el.addEventListener("click", () => this.closeDrawer())
    );
    if (this.trigger) {
      this.trigger.addEventListener("click", () => this.openDrawer());
    }

    this.setFocus = debounce((event) => {
      trapFocus(this, this.querySelector(".drawer__container"));
    }, 600);

    // ADA change July 2026: Initialize closed drawer with non-focusable child elements
    if (this.drawer && !this.drawer.classList.contains("drawer--active")) {
      this.disableDrawerFocus();
    }
  }

  // ADA change July 2026: Disable tab focus for all focusable elements inside closed drawer
  disableDrawerFocus() {
    if (!this.drawer) return;
    const focusables = this.drawer.querySelectorAll("button, [href], input, select, textarea, [tabindex]");
    focusables.forEach((el) => {
      if (!el.hasAttribute("data-drawer-prev-tabindex")) {
        el.setAttribute("data-drawer-prev-tabindex", el.getAttribute("tabindex") || "");
      }
      el.setAttribute("tabindex", "-1");
    });
  }

  // ADA change July 2026: Restore tab focus for focusable elements when drawer opens
  enableDrawerFocus() {
    if (!this.drawer) return;
    const focusables = this.drawer.querySelectorAll("button, [href], input, select, textarea, [tabindex]");
    focusables.forEach((el) => {
      const prev = el.getAttribute("data-drawer-prev-tabindex");
      if (prev !== null) {
        if (prev === "") {
          el.removeAttribute("tabindex");
        } else {
          el.setAttribute("tabindex", prev);
        }
        el.removeAttribute("data-drawer-prev-tabindex");
      } else {
        el.removeAttribute("tabindex");
      }
    });
  }

  openDrawer() {
    // ADA change July 2026: Enable keyboard focus on drawer items when opened
    this.enableDrawerFocus();

    // Calculate scrollbar width to prevent layout shift
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    if (scrollbarWidth > 0) {
      document.documentElement.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);
    }
    
    this.setFocus();
    // Add drawer--open to both body and html for scrollbar compensation
    document.body.classList.add("drawer--open");
    document.documentElement.classList.add("drawer--open");
    // Use requestAnimationFrame for smoother animation start
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.drawer.classList.add("drawer--active");
      });
    });
    // Search drawer keeps focus on input; other drawers focus the close button
    if (!this.classList.contains("global-search")) {
      setTimeout(() => {
        const firstBtn = this.drawer.getElementsByTagName("button")[0];
        if (firstBtn) firstBtn.focus();
      }, 500);
    }
  }

  closeDrawer() {
    // ADA change July 2026: Disable keyboard focus on drawer items when closed
    this.disableDrawerFocus();

    this.drawer.classList.remove("drawer--active");
    removeTrapFocus();
    
    // Wait for the drawer animation to complete before removing drawer--open
    // This prevents layout shift from scrollbar reappearing during animation
    let animationCompleted = false;
    const handleAnimationEnd = () => {
      if (animationCompleted) return; // Prevent double execution
      animationCompleted = true;
      
      document.body.classList.remove("drawer--open");
      document.documentElement.classList.remove("drawer--open");
      // Remove scrollbar compensation after a brief moment
      setTimeout(() => {
        document.documentElement.style.removeProperty('--scrollbar-width');
      }, 100);
      if (this.classList.contains("global-search")) {
        document.getElementById("SearchDrawerTrigger").focus();
      }
    };
    
    // Listen for transition end on the drawer container (where the transform happens)
    const drawerContainer = this.drawer.querySelector('.drawer__container');
    if (drawerContainer) {
      drawerContainer.addEventListener('transitionend', handleAnimationEnd, { once: true });
      // Fallback timeout in case transitionend doesn't fire (shouldn't happen, but safety)
      setTimeout(handleAnimationEnd, 550);
    } else {
      // Fallback if container not found
      setTimeout(handleAnimationEnd, 500);
    }
    
    document.activeElement.blur();
  }
}
customElements.define("main-drawer", MainDrawer);

class DetailsDrawer extends MainDrawer {
  constructor() {
    super();

    this.details = this.querySelector("details");
  }

  closeDrawer() {
    this.drawer.classList.remove("drawer--active");
    removeTrapFocus();
    
    // Wait for the drawer animation to complete before removing drawer--open
    // This prevents layout shift from scrollbar reappearing during animation
    let animationCompleted = false;
    const handleAnimationEnd = () => {
      if (animationCompleted) return; // Prevent double execution
      animationCompleted = true;
      
      document.body.classList.remove("drawer--open");
      document.documentElement.classList.remove("drawer--open");
      // Remove scrollbar compensation after a brief moment
      setTimeout(() => {
        document.documentElement.style.removeProperty('--scrollbar-width');
      }, 100);
      this.details.removeAttribute("open");
    };
    
    // Listen for transition end on the drawer container (where the transform happens)
    const drawerContainer = this.drawer.querySelector('.drawer__container');
    if (drawerContainer) {
      drawerContainer.addEventListener('transitionend', handleAnimationEnd, { once: true });
      // Fallback timeout in case transitionend doesn't fire (shouldn't happen, but safety)
      setTimeout(handleAnimationEnd, 550);
    } else {
      // Fallback if container not found
      setTimeout(handleAnimationEnd, 500);
    }
    
    document.activeElement.blur();
  }
}
customElements.define("details-drawer", DetailsDrawer);
class SearchDrawer extends MainDrawer {
  constructor() {
    super();

    this.setFocus = debounce((event) => {
      trapFocus(this, this.querySelector(".search-drawer"));
      document.getElementById("SearchInput").focus();
    }, 600);

    document
      .getElementById("SearchDrawerTrigger")
      .addEventListener("click", (e) => {
        this.openDrawer();
        this.setFocus();
        if (
          !document.getElementById("PREDICTIVESEARCHCSS") &&
          document.getElementById("PREDICTIVESEARCHJS")
        ) {
          this.classList.add("loading");
        }
        if (this.querySelector("predictive-search")) {
          loadScript("predictive-search").catch((error) => {
            console.error(error);
          });
          loadCss("predictive-search")
            .then(() => {
              this.classList.remove("loading");
            })
            .catch((error) => {
              console.error(error);
            });
        }
      });
  }
}
customElements.define("search-drawer", SearchDrawer);
class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.hide()
    );
    this.querySelectorAll(".modal__close").forEach((el) =>
      el.addEventListener("click", () => this.hide())
    );
    this.querySelector(".modal-trigger").addEventListener(
      "click",
      this.show.bind(this)
    );
  }

  hide() {
    this.querySelector("dialog")?.removeAttribute("open");
    this.querySelector(".dialog")?.classList.remove("dialog--open");
    this.querySelector(".modal").classList.remove("modal--active");
    document.body.classList.remove("modal--open");
    removeTrapFocus(this);
  }

  show() {
    this.querySelector("dialog")?.setAttribute("open", "");
    this.querySelector(".dialog")?.classList.add("dialog--open");
    this.querySelector(".modal").classList.add("modal--active");
    document.body.classList.add("modal--open");
    // console.log('this')
    // console.log(this)
    trapFocus(this);
  }
}
customElements.define("modal-dialog", ModalDialog);
class SearchDialog extends ModalDialog {
  constructor() {
    super();

    this.querySelector(".modal-trigger").addEventListener(
      "click",
      this.loadAssets.bind(this)
    );
  }

  loadAssets() {
    this.show();
    setTimeout(() => {
      document.getElementById("SearchInput").focus();
    }, 500);
    if (
      !document.getElementById("PREDICTIVESEARCHCSS") &&
      !document.getElementById("PREDICTIVESEARCHJS")
    ) {
      this.classList.add("loading");
    }
    if (this.querySelector("predictive-search")) {
      loadScript("predictive-search").catch((error) => {
        console.error(error);
      });
      loadCss("predictive-search")
        .then(() => {
          this.classList.remove("loading");
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }
}
customElements.define("search-dialog", SearchDialog);
// Back to top
(function backToTop() {
  const trigger = document.querySelector(".btn--back-to-top");

  if (trigger) {
    const backToTopReveal = (e) => {
      if (window.pageYOffset >= 50) {
        trigger.classList.add("btn--back-to-top__revealed");
      } else {
        trigger.classList.remove("btn--back-to-top__revealed");
      }
    };

    backToTopReveal();
    window.addEventListener("scroll", backToTopReveal);

    trigger.addEventListener("click", (e) => {
      window.scrollTo({ top: 0, behavior: "smooth" });
      setTimeout(() => {
        document
          .getElementsByClassName("site-logo")[0]
          .getElementsByTagName("a")[0]
          .focus();
      }, 1000);
    });
  }
})();

// Page transition
window.addEventListener("beforeunload", () => {
  document.body.classList.add("unloading");
});
window.addEventListener("DOMContentLoaded", () => {
  document.body.classList.add("loaded");
});
window.addEventListener("pageshow", (event) => {
  // Removes unload class when returning to page via history
  if (event.persisted) {
    document.body.classList.remove("unloading");
  }
});

const productFormObserver = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        loadScript("product-form").catch((error) => {
          console.error(error);
        });
        productFormObserver.unobserve(entry.target);
      }
    });
  },
  { rootMargin: "0px 0px 250px 0px" }
);

document
  .querySelectorAll("[product-form-oberver]")
  .forEach((el) => productFormObserver.observe(el));

const imageObserver = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("loaded");
        imageObserver.unobserve(entry.target);
      }
    });
  },
  { threshold: 0.25 }
);

document
  .querySelectorAll('img[loading="lazy"]')
  .forEach((el) => imageObserver.observe(el));

// const showStoredItems = () => {
//   const storedItemsList = JSON.parse(window.sessionStorage.getItem('elevated:item-added') || '[]');

//   document.querySelectorAll('.product-card').forEach((el) => {
//     if (storedItemsList.indexOf(parseInt(el.id)) !== -1) {
//       el.classList.add('in-cart');
//     }
//   });
// };

// showStoredItems();

document.addEventListener("DOMContentLoaded", function () {
  const colorFieldset = document.querySelector("fieldset.color");

  if (colorFieldset) {
    const selectedOption = document.getElementById("selectedOption");

    // Handle radio inputs
    const radioInputs = colorFieldset.querySelectorAll(".variant-option");
    radioInputs.forEach(function (input) {
      input.addEventListener("mouseover", function () {
        const hoveredValue = this.value;
        selectedOption.textContent = hoveredValue;
      });

      input.addEventListener("mouseout", function () {
        const originalValue = colorFieldset.querySelector(
          ".variant-option:checked"
        ).value;
        selectedOption.textContent = originalValue;
      });
    });

    // Handle anchor elements
    const anchorElements = colorFieldset.querySelectorAll("a[title]");
    anchorElements.forEach(function (anchor) {
      anchor.addEventListener("mouseover", function () {
        const hoveredValue = this.title;
        selectedOption.textContent = hoveredValue;
      });

      anchor.addEventListener("mouseout", function () {
        const originalValue = colorFieldset.querySelector(
          ".variant-option:checked"
        ).value;
        selectedOption.textContent = originalValue;
      });
    });
  }
});

document.querySelectorAll(".details .summary").forEach((summary) => {
  summary.addEventListener("click", (event) => {
    const anchor = event.target.closest("a");
    if (anchor) {
      // If it's an anchor, navigate to the href
      window.location.href = anchor.href;
      event.preventDefault();
    }
  });
});

// Desktop Menu on hover show megamenu or single-dropdown
(function() {
  const dm = document.getElementsByClassName("desktop-menu")[0];
  if (!dm) return;
  const submenuArr = Array.from(dm.getElementsByClassName("has-submenu"));
submenuArr.forEach((el) => {
  let elMenuArr = [];
  Array.from(el.getElementsByClassName("megamenu")).forEach((m) => {
    elMenuArr.push(m);
  });
  Array.from(el.getElementsByClassName("single-dropdown")).forEach((m) => {
    elMenuArr.push(m);
  });

  //el.addEventListener('mouseover', addShow);
  el.addEventListener("mouseenter", addShow);
  //el.addEventListener('mouseleave', addHide);
  el.addEventListener("mouseleave", hideAll);

  Array.from(el.getElementsByClassName("toggle-btn")).forEach((btn) => {
    btn.addEventListener("click", (e) => {
      if (
        e.currentTarget.parentNode.parentNode
          .getElementsByClassName("details__content")[0]
          .classList.contains("show")
      ) {
        hideAll();
      } else {
        hideAll();

        elMenuArr.forEach((m) => {
          m.classList.remove("hide");
        });
        setTimeout(() => {
          elMenuArr.forEach((m) => {
            m.classList.remove("hide");
            m.classList.add("show");
          });
        }, 5);
        e.currentTarget.parentNode
          .getElementsByTagName("button")[0]
          .setAttribute("aria-expanded", true);
      }
    });
    //btn.addEventListener('click', addShow);
  });

  Array.from(el.getElementsByClassName("toggle-btn")).forEach((btn) => {
    btn.addEventListener("keydown", (e) => {
      if (e.code.toLowerCase() == "tab" && e.shiftKey === true) {
        hideAll();
      }
    });
  });

  function addShow() {
    //this.getElementsByClassName('details')[0].classList.add('details--active');
    //hide all
    hideAll();

    elMenuArr.forEach((m) => {
      m.classList.remove("hide");
    });
    setTimeout(() => {
      elMenuArr.forEach((m) => {
        m.classList.remove("hide");
        m.classList.add("show");
      });
    }, 5);
    //console.log(`this.getElementsByClassName('summary')[0].getElementsByTagName('a')[0]`)
    //console.log(this.getElementsByClassName('summary')[0].getElementsByTagName('a')[0])

    this.getElementsByClassName("summary")[0]
      .getElementsByTagName("button")[0]
      .setAttribute("aria-expanded", true);
  }

  function addHide() {
    elMenuArr.forEach((m) => {
      m.classList.remove("show");
      m.classList.add("hide");
    });
  }

  elMenuArr.forEach((m) => {
    let itemsArr = Array.from(m.getElementsByTagName("a"));
    let lastItem = itemsArr[itemsArr.length - 1];
    let firstItem = itemsArr[0];
    lastItem.addEventListener("keydown", (e) => {
      if (e.code.toLowerCase() == "tab" && e.shiftKey === false) {
        hideAll();
      }
    });

    firstItem.addEventListener("keydown", (e) => {
      if (e.code.toLowerCase() == "tab" && e.shiftKey === true) {
        hideAll();
      }
    });
  });
});

function hideAll() {
  submenuArr.forEach((ele) => {
    let menuArr = [];
    Array.from(ele.getElementsByClassName("megamenu")).forEach((m) => {
      menuArr.push(m);
    });
    Array.from(ele.getElementsByClassName("single-dropdown")).forEach((m) => {
      menuArr.push(m);
    });

    menuArr.forEach((m) => {
      m.classList.add("hide");
      m.classList.remove("show");
      //m.parentNode.getElementsByClassName('summary')[0].getElementsByTagName('a')[0].setAttribute('aria-expanded', false);
      Array.from(m.parentNode.getElementsByClassName("toggle-btn")).forEach(
        (toggleBtn) => {
          toggleBtn.setAttribute("aria-expanded", false);
        }
      );
      // No longer setting aria-expanded on anchor links
      //Array.from(m.parentNode.getElementsByClassName('toggle-btn')).forEach(toggleBtn => {
      //toggleBtn.setAttribute('aria-expanded', false);
      //})
      //m.parentNode.getElementsByClassName('toggle-btn')[0].setAttribute('aria-expanded', false);
    });
  });
}
})();

/*
const mobileMediaQuery = window.matchMedia("(max-width: 768px)");
mobileMediaQuery.addEventListener('change', e => {
  if(e.matches) {

  }
})

if(window.innerWidth > 768){
  Array.from(document.getElementsByClassName('site-footer')[0].getElementsByClassName('details')).forEach( el => {
    let btn = el.getElementsByTagName('button')[0];
    btn.removeAttribute('aria-controls');
    btn.removeAttribute('aria-expanded');
    btn.removeAttribute('aria-label');
    btn.setAttribute('role', "heading");
  })

}
*/
// mobile menu - reset trapFocus - clickable elements within accordions are not listed as "elements" in the trapFocus function.
// Below we add a click event that calls trapFocus when an accordion is opened so that the submenu items can
// be added to the list of elements. Otherwise the submenu items can't be tabbed to.

const mmenuDrawer = document.getElementsByClassName("mmenu-drawer")[0];
const siteMenu = mmenuDrawer?.getElementsByClassName("site-menu")[0];
const summaryElements = siteMenu?.getElementsByClassName("summary");

if (summaryElements) {
  Array.from(summaryElements).forEach((el) => {
    el.addEventListener("click", (e) => {
      setTimeout(() => {
        //console.log('reset trapFocus')
        removeTrapFocus();
        trapFocus(document.getElementById("Details-Menu-Trigger"), el);
      }, 100);
    });
  });
}

document.addEventListener("keydown", (e) => {
  //console.log(e.key)
  //console.log(e.target)
});

// Initialize product form input label click handlers
function initializeProductFormInputs(container = document) {
  container.querySelectorAll(".product-form__input").forEach((wrapper) => {
    // Skip if already initialized
    if (wrapper.hasAttribute("data-input-initialized")) return;
    
    const labels = wrapper.querySelectorAll("label");

    labels.forEach((label) => {
      label.addEventListener("click", () => {
        labels.forEach((l) => l.classList.remove("is-selected"));
        label.classList.add("is-selected");
      });
    });
    
    // Mark as initialized to prevent duplicate listeners
    wrapper.setAttribute("data-input-initialized", "true");
  });
}

// Initialize on page load
initializeProductFormInputs();

// Make it available globally for dynamic product loading
window.initializeProductFormInputs = initializeProductFormInputs;

class CardSlider extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.sliderDots = this.querySelectorAll(".slider-dot");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    // const resizeObserver = new ResizeObserver((entries) => this.initPages());
    // resizeObserver.observe(this.slider);
    if (window.innerWidth > 768) {
      const resizeObserver = new ResizeObserver((entries) => this.initPages());
      resizeObserver.observe(this.slider);
    }

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));

    // ADA #328: Re-init focus handling when slider becomes visible (display:none → block)
    this._visibilityObserver = new MutationObserver(() => {
      if (this.classList.contains("is-active")) {
        this.resetPages();
        this.updateSlideFocus();
      } else {
        this.updateSlideFocus(true);
      }
    });
    this._visibilityObserver.observe(this, {
      attributes: true,
      attributeFilter: ["class"],
    });
    this.updateSlideFocus(!this.classList.contains("is-active"));

    // Add click event listeners to dots
    this.sliderDots.forEach((dot, index) => {
      dot.addEventListener("click", () => {
        const slidePosition =
          this.sliderItemsToShow[index].offsetLeft -
          this.sliderItemsToShow[0].offsetLeft;
        this.slider.scrollTo({
          left: slidePosition,
          behavior: "smooth",
        });
      });
    });
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    // Update dots active state
    if (this.sliderDots.length > 0) {
      this.sliderDots.forEach((dot, index) => {
        if (index === this.currentPage - 1) {
          dot.classList.add("active");
        } else {
          dot.classList.remove("active");
        }
      });
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    this.updateSlideFocus();

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  // ADA #328: Off-screen / inactive slides must not receive focus or be exposed to screen readers
  updateSlideFocus(forceHide = false) {
    if (!this.sliderItems || !this.sliderItems.length) return;

    const hideAll = forceHide || !this.classList.contains("is-active");
    const hasMultipleSlides =
      this.sliderItemsToShow && this.sliderItemsToShow.length > 1;

    Array.from(this.sliderItems).forEach((slide) => {
      let isVisible = false;
      if (!hideAll) {
        isVisible = hasMultipleSlides
          ? this.sliderItemsToShow.includes(slide) && this.isSlideVisible(slide)
          : true;
      }

      if ("inert" in HTMLElement.prototype) {
        slide.inert = !isVisible;
      } else {
        slide.setAttribute("aria-hidden", isVisible ? "false" : "true");
        slide.querySelectorAll("a, button, input, select, textarea").forEach((el) => {
          if (isVisible) {
            el.removeAttribute("tabindex");
          } else {
            el.setAttribute("tabindex", "-1");
          }
        });
      }
    });
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define("card-slider", CardSlider);

